import axios from "axios";
import {API_DOMAIN} from "../constants";

export async function getGolferOrderActionTypes() {
    const response = await axios({
        url: API_DOMAIN + "/api/v2/golferOrderActionTypes",
        method: "GET",
        headers: {
            Authorization: localStorage.getItem("MFE_TOKEN"),
        },
    });

    return response.data;
}
